import React, { type FC } from 'react'
import { type SxProps, type Theme, Typography } from '@mui/material'

import { selectExplorerTailSize, Translation } from '../../../../domain'

import { TextField } from '../../common'
import { FormattedTranslation } from '../../Internationalization'
import { useAppState, useAppUsecase } from '../../State'

const titleStyle: SxProps<Theme> = { my: 'auto', mx: 2, lineHeight: 3 }
const fieldStyle: SxProps<Theme> = { width: 80, justifyContent: 'center' }

export const TailSize: FC = () => {
    const tailSize = useAppState(selectExplorerTailSize)
    const updateTail = useAppUsecase('updateExplorerTailUsecase')

    return (
        <>
            <Typography sx={titleStyle} variant="body1">
                <FormattedTranslation id={Translation.TAIL_SIZE} />
            </Typography>
            <TextField
                data-testid="topicsTailSize"
                sx={fieldStyle}
                type="number"
                value={tailSize}
                onChange={({ target: { value } }) => updateTail.updateTailSize(Math.round(Number(value)))}
            />
        </>
    )
}
